import { createSlice } from '@reduxjs/toolkit';
import { User } from '../../models/user.model';

const initialState: User = {
	user_email: '',
	user_name: '',
	id: '',
	roles: {
		adminAppAccess: false,
		adminAppNoAccess: false,
		adminAppEditOthersOwnedRecruit: false,
		adminAppAttachRecruitDocs: false,
		adminAppAddNotes: false,
		adminAppAddRecruit: false,
		adminAppChangeRecruitStatus: false,
		adminAppAccessedUserListInclusion: false,
		recruitAppAccess: false,
		recruitAppAttachMyDocs: false,
		recruitAppManageMyNotes: false,
		recruitAppImpersonateAnyone: false,
	},
};

const userReducerSlice = createSlice({
	name: 'userReducer',
	initialState,
	reducers: {
		setUser(state: User, action) {
			return {
				...state,
				...action.payload,
			};
		},
	},
});

export const { setUser } = userReducerSlice.actions;
export default userReducerSlice.reducer;
